import React, { useContext, useMemo } from 'react';
import { useTheme } from 'styled-components';
import { HeaderCheckbox } from '../components/header-checkbox';
import { CellCheckbox } from '../components/cell-checkbox';
import { TableSettingsContext } from '../table-settings-context';
const preventClick = (e) => {
    e.stopPropagation();
};
const isDisabledSelection = (row) => { var _a; return ((_a = row.original) === null || _a === void 0 ? void 0 : _a.disabledSelection) || false; };
export const useSelection = (selectable) => {
    const { sizeUnit } = useTheme();
    const { checkboxType } = useContext(TableSettingsContext);
    const style = useMemo(() => ({
        width: sizeUnit * 13
    }), [sizeUnit]);
    return (hooks) => {
        hooks.visibleColumnsDeps.push((deps) => [...deps, selectable]);
        hooks.visibleColumns.push((columns) => {
            return selectable
                ? [
                    {
                        id: 'selection',
                        isVirtualColumn: true,
                        disableFilters: true,
                        disableResizing: true,
                        disableSortBy: true,
                        disableGroupBy: true,
                        style,
                        Header: ({ page, toggleRowSelected, isAllPageRowsSelected }) => {
                            const modifiedOnChange = (event) => {
                                page.forEach((row) => {
                                    !isDisabledSelection(row) &&
                                        toggleRowSelected(row.id, event.currentTarget.checked);
                                });
                            };
                            let selectableRowsInCurrentPage = 0;
                            let selectedRowsInCurrentPage = 0;
                            page.forEach((row) => {
                                row.isSelected && selectedRowsInCurrentPage++;
                                !isDisabledSelection(row) && selectableRowsInCurrentPage++;
                            });
                            return (React.createElement(HeaderCheckbox, { onChange: (e) => modifiedOnChange(e), checked: isAllPageRowsSelected }));
                        },
                        Cell: ({ row }) => {
                            return (React.createElement(CellCheckbox, { ...row.getToggleRowSelectedProps(), disabled: Boolean(isDisabledSelection(row)), ariaLabel: `${row.index}`, filled: checkboxType === 'filled', 
                                // for prevent event bubbling. It triggered onRowClick.
                                // @ts-ignore
                                onClick: preventClick }));
                        },
                        className: 'invent-table-select'
                    },
                    ...columns
                ]
                : columns;
        });
    };
};
